













import Vue from 'vue';
import Component from 'vue-class-component';
import { INote } from '@/entities/note/note.interface';
import * as types from '@/store/types';

@Component({})
export default class AppContainer extends Vue {
  public created() {
      this.$store.dispatch(types.APP_START);
  }

  get notes(): INote[] {
    return this.$store.state.note.notes;
  }

  public logout() {
    this.$store.dispatch(types.AUTH_LOGOUT);
    this.$router.push('/login');
  }
}
